import { GeckoPermsContext } from 'features/permissions/contexts/GeckoPermissionsProvider'
import { useContext } from 'react'

export const useGeckoPermissions = () => {
  const context = useContext(GeckoPermsContext)
  if (!context)
    throw new Error(
      'useGeckoPermissions() must be used within GeckoPermissionsProvider'
    )
  return context
}
